/**
 * Custom Error thrown when we cannot use controller directly in `fetch`.
 * Error name is same as official AbortError.
 * @see https://developers.google.com/web/updates/2017/09/abortable-fetch
 */
const ABORT_ERROR_NAME = 'AbortError';

class AbortError extends Error {
  constructor(message?: string) {
    super(message || 'Action was canceled');
    this.name = ABORT_ERROR_NAME;
  }
}

export async function waitAsync(
  durationMs?: number,
  abortSignal?: AbortSignal
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (abortSignal) {
      abortSignal.onabort = () => reject(new AbortError());
      if (abortSignal.aborted) {
        reject(new AbortError());
        return;
      }
    }
    setTimeout(resolve, durationMs);
  });
}
